import Vue from "vue";
import VueRouter from "vue-router";
import { MessageBox } from "element-ui";

import axios from "@/axios/index";

Vue.use(VueRouter);

const routes = [
  {
    path: "/login",
    // redirect: "/login",
    component: () => import("../views/login.vue"),
    beforeEnter: (to, from, next) => {
      //console.log(to, from )

      //初始化进入登录页
      sessionStorage.clear();

      if (to.query.caseId && to.query.caseId != "0") {
        sessionStorage.setItem("userName", to.query.userName);
        sessionStorage.setItem("userEmpno", to.query.userId);
        sessionStorage.setItem("contactphone", to.query.userPhone);
        sessionStorage.setItem("contactNo", to.query.account);
        sessionStorage.setItem("OAID", to.query.password);
        sessionStorage.setItem("userId", "1");
        sessionStorage.setItem(
          "rptmaint_view_all",
          to.query.rptmaint_view_all || "F"
        ); //是否展示“所有列表”
        sessionStorage.setItem("running_env", "Browser");
        if (navigator.userAgent.includes("JavaFX") == true) {
          sessionStorage.setItem("running_env", "XMS"); //设置内嵌环境
        }

        sessionStorage.setItem("caseId", to.query.caseId);
        const data = {
          userPhone: to.query.userPhone,
          account: to.query.account,
          password: to.query.password,
        };
        const str1 = EncryptUtil.sm2Encrypt(data);
        axios({
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
          url:
            process.env.VUE_APP_API +
            "common/warrantyInterface_action!loginWebXMSnew.action",
          method: "post",
          data: {
            data: decodeURIComponent(str1),
          },
        }).then((res) => {
          let result = res.data.result;
          let msg = res.data.msg || res.data.message || "";

          if (result) {
            if (res.data.user.id != 1) {
              //注册过的用户
              sessionStorage.setItem("userName", res.data.user.userName);
              sessionStorage.setItem("userId", res.data.user.id);
            }
            sessionStorage.setItem("hotelName", res.data.clientName);
            next("/repairNew?caseId=" + to.query.caseId);
          } else {
            //未注册用户跳转自动报修界面
            if (msg.includes("WB001")) {
              sessionStorage.setItem("hotelName", res.data.clientName);
              next("/repairNew?caseId=" + to.query.caseId);
            } else {
              if (msg.indexOf("请求时间戳已过期") >= 0) {
                MessageBox.alert(
                  "登录失败，当前系统时间误差较大，请及时修改",
                  "提示",
                  {
                    type: "warning",
                    confirmButtonText: "确定",
                  }
                );
              }
              next();
            }
          }
        });
      } else {
        next();
      }
    },
    // children: [
    //   {
    //     path: "/login",
    //     name: "login",
    //     component: () => import('../views/login.vue'),

    //   },
    // ],
  },
  {
    path: "/onlineconsult",
    component: () => import("./../components/Refer.vue"),
  },
  {
    path: "/initQuest",
    name: "initQuest",
    component: () => import("../views/initQuest.vue"),
  },
  // {
  //   path: "/faqtomd",
  //   name: "faqtomd",
  //   component: () => import("../components/faqToMd.vue"),
  // },
  {
    path: "/index",
    name: "index",
    component: () => import("../views/index.vue"),
    meta: {
      requireAuth: true,
    },
    children: [
      {
        path: "/home",
        name: "home",
        component: () => import("../views/home.vue"),
        meta: {
          requireAuth: true,
        },
      },
      // {
      //   path: "/readme",
      //   name: "readme",
      //   component: () => import("../views/readme.vue"),
      //   meta: {
      //     requireAuth: true,
      //   },
      // },
      {
        path: "/repairNew",
        name: "repairNew",
        component: () => import("../views/repairNew.vue"),
        meta: {
          requireAuth: true,
        },
      },
      {
        path: "/repairList",
        name: "repairList",
        component: () => import("../views/repairList.vue"),
        meta: {
          requireAuth: true,
        },
      },
      {
        path: "/repairDetail",
        name: "repairDetail",
        beforeEnter(to, from, next) {
          // repairDetail固定会传入{ caseId: id, toPath: fromPath }，防止刷新页面参数丢失，进行session存储

          if (to.params.caseId) {
            sessionStorage.setItem("repairDetail-caseId", to.params.caseId);
          }
          if (to.params.toPath) {
            sessionStorage.setItem("repairDetail-toPath", to.params.toPath);
          }

          next();
        },
        component: () => import("../views/repairDetail.vue"),
        meta: {
          requireAuth: true,
        },
      },
      {
        path: "/onlineDoc",
        name: "onlineDoc",
        component: () => import("../views/onlineDoc.vue"),
        meta: {
          requireAuth: true,
        },
      },
      // 新建携程表单
      {
        path: "/otaForm",
        name: "otaForm",
        component: () => import("../views/otaForm.vue"),
        meta: {
          requireAuth: true,
        },
      },
    ],
  },
];

const router = new VueRouter({
  mode: "history",
  routes,
});

// 路由守卫
router.beforeEach((to, from, next) => {
  console.log(to);
  if (to.matched.length != 0) {
    if (to.meta.requireAuth) {
      // 需要登录后才有权限进入
      if (sessionStorage.getItem("userId")) {
        // 已登录
        next();
      } else {
        // 未登录则无权限进入，跳转登录页
        next({
          path: "/login",
          query: to.query,
        });
      }
    } else {
      // 不需要登录也有权限进入
      if (sessionStorage.getItem("userId")) {
        // 若已登录
        if (to.path != "/" || to.path != "login") {
          // 目标路由非登录页
          next();
        } else {
          // 若目标路由是登录页但已登录，直接跳转至首页
          // console.log(333);
          next({
            path: "/index",
          });
        }
      } else {
        // 未登录即游客身份，可以进入无权限要求的页面
        next();
      }
    }
  } else {
    next({ path: "/login" });
  }
});

export default router;
